import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./flexomniquery-widget.html';
import UtilsService from '../../../services/utils.service';
import _ from 'lodash';
import '../../../app/bindings/ko-bindinghandler-tokenfield';
import UtilService from '../../../services/utils.service';
import Vue from 'vue';
import vuetify from '../../../plugins/vuetify';
import FilterExpression from '../../../vueComponents/filterExpression/src/filterExpression.vue';
import MetadataService from "../../../services/metadata.service";
import DataService from "../../../modules/assurance/services/data.service";
import VueDatasetService from "../../../services/vue-dataset-view.service";

const OPERATOR_DISPLAY_TEXT_MAP = {
    'in': 'in',
    'notin': 'not in',
    '=': 'equals',
    '!=': 'does not equal',
    '>': 'is greater than',
    '>=': 'is greater than or equal to',
    '<': 'is less than',
    '<=': 'is less than or equal to',
    like: 'contains',
};

const FILTER_OPERATOR_MAP = {
  'string': {
    'in': 'in',
    'not in': 'notin',
    'equals': '=',
    'does not equal': '!=',
    'contains': 'like',
    'does not contain': 'notlike',
    'starts with': 'startswith',
    'ends with': 'endswith'
  },
  'uuid': {
    'equals': '=',
    'does not equal': '!='
  },
  'number': {
    'equals': '=',
    'does not equal': '!=',
    'is less than': '<',
    'is less than or equal to': '<=',
    'is greater than': '>',
    'is greater than or equal to': '>=',
    'less than': '<',
    'less than or equal to': '<=',
    'greater than': '>',
    'greater than or equal to': '>=',
  },
  // 'datetime': {
  //   'is prior to': '<',
  //   'is on or prior to': '<=',
  //   'is after': '>',
  //   'is on or after': '>='
  // },
  'list': {
    'in': 'in',
    'not in': 'notin'
  }
};

const REVERSE_FILTER_OPERATOR_MAP = {
  'string': _.invert(FILTER_OPERATOR_MAP['string']),
  'uuid': _.invert(FILTER_OPERATOR_MAP['uuid']),
  'number': _.invert(FILTER_OPERATOR_MAP['number']),
  'list'  : _.invert(FILTER_OPERATOR_MAP['list'])
};

function getOperatorDisplayText(operator) {
    var displayText = OPERATOR_DISPLAY_TEXT_MAP[operator];
    if (_.isUndefined(displayText)) {
        console.error('flexomniquery-widget::getOperatorDisplayText: Could not find operator "' + operator + '"');
        return '??';
    }
    return displayText;
}

function flexomniqueryWidget(params) {
    var self = this;

    self.id = UtilsService.generateID();
    self.params = params;
    self.observableOptions = params.observableOptions;
    self.columnOptionsObs = params.columnOptionsObs;
    self.returnExpressionObs = ko.observable();
    self.visibilityOptions = params.visibilityOptions;
    self.vueFilterID = 'vueFilterExpression-' + UtilService.generateID();
    self.filters = [];
    self.filterExpressionOperator = 'and';

    self.subscriptions = [];

    self.typeaheadDisplayMode = params.typeaheadDisplayMode || 'typeahead-full';
    
    self.acceptedTokens = ko.observableArray();
    self.observableData = params.observableData;
    self.panelTemplate = params.panelTemplate;
    self.validationMessage = ko.observable(false);
    self.widgetSignals = params.widgetSignals;

    if (isObservableDataLoaded(params.observableData) && self.widgetSignals && self.widgetSignals().dataLoaded) {
        // trigger dataLoaded if the data was loaded prior to the widget being constructed
        self.widgetSignals().dataLoaded.dispatch();
    }
    
}

flexomniqueryWidget.prototype.koDescendantsComplete = function() {
    let self = this;

  var columnOptions = ko.pureComputed(function () {
    if (self.columnOptionsObs) {
      return self.columnOptionsObs();
    }
    return  self.params.observableOptions().columnOptions;
  });

  DataService.fetchAddCpmaDatasetMetadata().then((addCpmaMetadata) => {

    if (self.params.viewLevelOptions) {
      self.subscriptions.push(self.params.viewLevelOptions.subscribe(function () {
        if (self.loadMode) {
          return;
        }

        loadSavedCondition();
      }));
    }

    // we should be able to assume this subscription will always return a new filter condition rather than the legacy format conditions
    self.subscriptions.push(self.acceptedTokens.subscribe(function (tokensVal) {
      if (self.loadMode) {
        return;
      }

      var groups = !_.isEmpty(tokensVal) ? tokensVal : [];

      self.loadMode = true;
      self.params.viewLevelOptions({
        WhereConditionObj: groups,
        WhereConditionConjunction: self.filterExpressionOperator.toUpperCase()
      });

      self.loadMode = false;
    }));

    function loadSavedCondition() {
      let vlo = self.params.viewLevelOptions();
      let savedConditions = [];
      let columns = ko.unwrap(self.columnOptionsObs);

      if (!_.isEmpty(vlo) && vlo.WhereConditionObj) {
        if (vlo.WhereConditionObj.WhereConditionObj) {
          savedConditions = vlo.WhereConditionObj.WhereConditionObj;
        } else {
          savedConditions = vlo.WhereConditionObj;
        }

        savedConditions.forEach(function (savedCondition) {
          if (savedCondition.conditions) {
            savedCondition.conditions.forEach(cond => {
              if (!_.isEmpty(ko.unwrap(columnOptions))) {
                FixCondition(cond, ko.unwrap(columnOptions));
              }
            });
          } else {
            if (_.isEmpty(savedCondition.desc) || _.startsWith(savedCondition.desc, 'dim')) {
              if (!_.isEmpty(ko.unwrap(columnOptions))) {
                FixCondition(savedCondition, ko.unwrap(columnOptions));
              }
              if (
                !_.startsWith(savedCondition.selectedLhsTitle, 'dim') &&
                !_.isEmpty(savedCondition.selectedLhsTitle) &&
                !_.isEmpty(savedCondition.selectedOperator) &&
                !_.isEmpty(savedCondition.rhsText)) {
                savedCondition.desc = savedCondition.selectedLhsTitle + " " + savedCondition.selectedOperatorTitle + " " + savedCondition.rhsText;
              }
            }
          }
        });

        self.loadMode = true;
        translateConditionsToFilterExpression(savedConditions);
        self.acceptedTokens(translateFilterExpressionToConditions(self.filterExpressionGroups));
        handleDefaultFilters(self, columns);
        self.loadMode = false;
        self.acceptedTokens.valueHasMutated();
      } else {
        handleDefaultFilters(self, columns);
      }
    }

    function FixCondition(condition, columnOptions) {
      var lhs = columnOptions.filter(function (co) {
        return co.name === condition.selectedLhs;
      });
      var conditionValue;

      // todo I'm sure this is breaking some migration of legacy filters somewhere
      // condition.selectedLhsTitle = condition.selectedLhsTitle || (condition.lhstitle ? condition.lhstitle : condition.selectedLhs);

      if (lhs.length > 0) {
        condition.selectedLhsTitle = lhs[0].title;
      }
      if (condition.selectedOperator === 'in' || condition.selectedOperator === 'notin') {
        condition.selectedOperatorTitle = condition.selectedOperator === 'in' ? 'in' : 'not in';
        conditionValue = _.isArray(condition.selectedRhs) ? condition.selectedRhs.join(', ') : condition.selectedRhs;
        condition.listtype = true;
      } else {
        conditionValue = condition.rhsText;
        condition.listtype = false;
        condition.selectedRhs = [];
      }
      if (!condition.conjunctionVisible) {
        condition.conjunctionVisible = false;
      }
      if (!condition.hidden) {
        condition.hidden = false;
      }
      if (condition.optitle) {
        condition.selectedOperatorTitle = condition.optitle;
      } else if (condition.selectedOperator) {
        condition.selectedOperatorTitle = getOperatorDisplayText(condition.selectedOperator);
      }
      if (condition.selectedLhsTitle) {
        condition.desc = condition.selectedLhsTitle + " " + condition.selectedOperatorTitle + " " + conditionValue;
      }
    }

    function translateConditionsToFilterExpression(conditions) {
      let vlo = self.params.viewLevelOptions();
      let operator = (vlo && vlo.WhereConditionConjunction) ? vlo.WhereConditionConjunction.toLowerCase() : 'and';
      let filterGroups = [];
      if (conditions && conditions.length) {
        conditions.forEach(condition => {
          // confusingly, each "condition" in the new filter format has a "conditions" array as one of its parameters
          if (condition.conditions) { // new filter format
            if (!condition.selectedConjunction) {
              condition.selectedConjunction = 'AND';
            }
            let filterGroup = {
              operator: condition.selectedConjunction.toLowerCase(),
              filters: []
            };
            condition.conditions.forEach(cond => {
              filterGroup.filters.push(getFilterFromCondition(cond, addCpmaMetadata));
            });
            filterGroups.push(filterGroup);
          } else { // legacy filter format
            if (!filterGroups.length) {
              filterGroups.push({
                operator: 'and',
                filters: []
              })
            }
            filterGroups[0].filters.push(getFilterFromCondition(condition, addCpmaMetadata));
          }
        });
        // This is an example of a filterGroups array. Filters require a 'value' prop or the component won't render them properly.
        // let filterGroups = [
        //   {
        //     operator: 'and',
        //     filters: [{
        //       text: "Age is greater than 18",
        //       value: "18",
        //       etc . . .
        //     }]
        //   }
        // ];
        self.filterExpressionOperator = operator;
        self.filterExpressionGroups = filterGroups;
        if (self.vueFilter) {
          self.vueFilter.filterGroups = filterGroups;
          self.vueFilter.operator = operator;
        }
      }
    }

    self.subscriptions.push(self.columnOptionsObs.subscribe(function (columns) {
      if (self.vueFilter) {
        self.vueFilter.columns = convertColumns(columns, self);
      }
      if (self.loadMode) {
        return;
      }
      loadSavedCondition();
    }));

    loadSavedCondition();

    const elementId = '#' + self.vueFilterID;
    let element = document.getElementById(self.vueFilterID);
    // setup Vue filter component
    if (!self.vueFilter && element) {
      self.vueFilter = new Vue({
        el: elementId,
        data: function() {
          return {
            columns: [],
            operator: self.filterExpressionOperator,
            filterGroups: self.filterExpressionGroups
          };
        },
        computed: {
          shouldRenderApplyButton() {
            // Apply button should only be rendered on Analytics dataset pages
            let url = window.location.hash;
            const oo = self.params.observableOptions();
            return !!(['historical2/infrastructure', 'historical2/user', 'historical2/networks'].some(str => url.includes(str)) || (oo && oo.dataset));
          }
        },
        methods: {
          /**
           *
           * @param {array} filterGroups the array containing all filter groups in the current filter.
           * Each array object contains a "filters" array and an "operator" string.
           */
          handleFiltersUpdated: function(filterGroups) {
            self.filterExpressionGroups = filterGroups;
            self.filterExpressionOperator = filterGroups.operator || self.filterExpressionOperator;
            if (self.vueFilter) {
              self.vueFilter.filterGroups = self.filterExpressionGroups;
              self.vueFilter.operator = self.filterExpressionOperator;
            }

            self.acceptedTokens(translateFilterExpressionToConditions(self.filterExpressionGroups));
          },
          /**
           * @param {string} operator represents how the filter groups should be combined, either "and" or "or"
           */
          handleOperatorChanged: function(operator) {
            self.filterExpressionOperator = operator;
            self.vueFilter.operator = operator;
            self.acceptedTokens.valueHasMutated();
          }
        },
        render(h) {
          return h(FilterExpression, {
            props: {
              columns: this.columns,
              operator: this.operator,
              filterGroups: this.filterGroups,
              shouldRenderApply: this.shouldRenderApplyButton,
            },
            on: {
              'filters-updated': this.handleFiltersUpdated,
              'operator-changed': this.handleOperatorChanged,
            }
          });
        },
        vuetify
      });

      let columns = self.columnOptionsObs();
      if (columns && columns.length) {
        self.vueFilter.columns = convertColumns(columns, self);
      }
    }

  });
}

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
flexomniqueryWidget.prototype.dispose = function () {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
    if (self.vueFilter) {
      self.vueFilter.$destroy();
      self.vueFilter.$el.parentNode.removeChild(self.vueFilter.$el);
    }
};

// TODO UI-2501: this probably needs to be updated to handle quick pick filters
function translateFilterExpressionToConditions(filterExpressionGroups) {
  if (filterExpressionGroups && filterExpressionGroups.length) {
    let filtersArray = [];
    filterExpressionGroups.forEach(exp => {
      let op = exp.operator ? exp.operator.toUpperCase() : 'AND';
      if (exp.filters && exp.filters.length) {
        let conditions = [];
        exp.filters.forEach((filter, index) => {
          if (filter.field && filter.filterComplete && (filter.value || filter.valueType === 'noValue')) {
            let lhsTitle = filter.fieldText;
            let isListType = filter.type === 'list' || filter.operatorText === 'in' || filter.operatorText === 'notin';
            let rhsVal = isListType ? '' : filter.queryVar; // todo??
            let listVal = isListType && filter.queryVar ? filter.queryVar.split(',') : [];
            let operatorMap = FILTER_OPERATOR_MAP[filter.type];
            if (!operatorMap) {
              return;
            }
            let filterOp = operatorMap[filter.operatorText || filter.operator || filter.operatorValue];
            if (!filterOp) {
              // TODO: debug code, remove
              console.error('invalid filter operator', filter.operator);
              return;
            }
            let newFilter = {
              id: UtilsService.generateID(),
              selectedLhs: filter.field,
              selectedOperator: filterOp,
              rhsText: rhsVal,
              rhsCount: isListType ? listVal.length : '',
              filterType: filter.type,
              listtype: isListType,
              valueType: isListType ? 'string' : (filter.type === 'number') ? 'numeric' : filter.type, // the API expects string type for lists
              selectedRhs: isListType ? listVal : [],
              conjunctionVisible: false, // TODO: is this ever supposed to be true?
              hidden: false, // TODO: is this ever supposed to be true?
              selectedLhsTitle: lhsTitle,
              lhstitle: lhsTitle,
              optitle: filter.operatorText,
              desc: filter.text,
              shortDesc: filter.shortText,
              
              displayField: filter.displayField,
              treeValueBranchSelect: filter.treeValueBranchSelect,
              filterWidth: filter.filterWidth,
              knownValuePath: filter.knownValuePath,
              // knownValues: filter.knownValues,
              datasetId: filter.datasetId,
            };
            conditions.push(newFilter);
          }
        });
        filtersArray.push({ selectedConjunction: op.toUpperCase(), conditions })
      }
    })
    return filtersArray;
  }
}

function isObservableDataLoaded(observableData) {
    return _.isFunction(observableData);
}

// Converts the columns metadata to a format that the FilterExpression component can use
function convertColumns(originalColumns, self) {
  let newColumns = [];

  let sortedColumns = _.cloneDeep(originalColumns);
  sortedColumns.sort((a, b) => {
    let titleA = a.title.toLowerCase();
    let titleB = b.title.toLowerCase();
    if (titleA < titleB) return -1;
    if (titleA > titleB) return 1;
    return 0;
  });
  sortedColumns.forEach(col => {
    let type = convertType(col.type);
    if (type !== 'none') {
      let newCol = {
        field: col.name,
        title: col.title,
        filterType: type
      };
      if (col.displayId || col.displayField) {
        newCol.displayField = col.displayId || col.displayField;
      }
      if (col.knownValuePath) {
        newCol.knownValuePath = col.knownValuePath;
      }
      if (col.treeValueBranchSelect) {
        newCol.treeValueBranchSelect = col.treeValueBranchSelect;
      }
      if (col.filterWidth) {
        newCol.filterWidth = col.filterWidth;
      }
      if (col.knownValues) {
        newCol.knownValues = col.knownValues;
      }
      if (col.datasetId) {
        newCol.datasetId = col.datasetId;
      }
      newColumns.push(newCol);
    }
  });
  return newColumns;
}

function getFilterFromCondition(condition, addCpmaMetadata) {
  let value = condition.listtype ? condition.selectedRhs.join(',') : condition.rhsText;
  let shortText = condition.shortDesc || (condition.listtype ? condition.selectedRhs.join(', ') : condition.rhsText);
  let type = condition.filterType || (condition.listtype ? 'list' : convertType(condition.valueType)); // or condition for legacy filter?
  let operatorText = condition.optitle;
  if (!operatorText && condition.selectedOperator) {
    operatorText = REVERSE_FILTER_OPERATOR_MAP[type][condition.selectedOperator];
  }
  let filter = {
    field: condition.selectedLhs,
    fieldText: condition.selectedLhsTitle || condition.lhstitle,
    filterComplete: true,
    displayField: condition.displayField,
    treeValueBranchSelect: condition.treeValueBranchSelect,
    filterWidth: condition.filterWidth,
    knownValuePath: condition.knownValuePath,
    // knownValues: condition.knownValues,
    datasetId: condition.datasetId,
    operatorValue: condition.selectedOperator,
    text: condition.desc,
    shortText: shortText,
    queryVar: value,
    value,
    type,
    operatorText
  }
  MetadataService.updateCpmaColMetadata(addCpmaMetadata, filter.field, filter);
  return filter;
}

function convertType(type) {
  if (!type) return 'string';
  switch (type) {
    case 'numeric':
    case 'integer':
    case 'currency':
    case 'percentage':
      return 'number';
    case 'datetime':
      return 'none';
    case 'text':
    case 'tag': // TODO: this type applies to the Endpoint Tag column in the settings view. Is converting to "string" here safe?
    case 'string':
      return 'string';
    default:
      return 'none';
  }
};

function handleDefaultFilters(self, columns) {
  let filterExpressionGroups = (self.filterExpressionGroups && self.filterExpressionGroups.length > 0 && self.filterExpressionGroups[0].filters && self.filterExpressionGroups[0].filters.length > 0) 
    ? self.filterExpressionGroups 
    : VueDatasetService.getQuickStartFilterGroups(self.params.observableOptions().dataset) || [{ filters: [], operator: 'and' }]; // todo pass metadata

  self.filterExpressionGroups = filterExpressionGroups;
  if (self.vueFilter) {
    self.vueFilter.filterGroups = filterExpressionGroups;
  }
}



export default { viewModel: flexomniqueryWidget, template: templateMarkup };
